import { render, staticRenderFns } from "./merchant-info.vue?vue&type=template&id=e47401ea&scoped=true&"
import script from "./merchant-info.vue?vue&type=script&lang=js&"
export * from "./merchant-info.vue?vue&type=script&lang=js&"
import style0 from "./merchant-info.vue?vue&type=style&index=0&id=e47401ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47401ea",
  null
  
)

export default component.exports